import { Outlet, useParams } from "react-router-dom";
import PropertyCustomer from "./PropertyCustomer/Property";

const Tab5 = () => {
  const { Id } = useParams();

  return Id ? <Outlet /> : <PropertyCustomer />;
};

export default Tab5;
